{
  "required": "Ce champ est requis",
  "invalid": "Ce champ est invalide",
  "firstNameRequired": "Le prénom est requis",
  "lastNameRequired": "Le nom est requis",
  "emailRequired": "L'adresse courriel est requise",
  "emailInvalid": "L'adresse courriel est invalide",
  "passwordRequired": "Le mot de passe est requis",
  "passwordsMustMatch": "Les mots de passe doivent correspondre",
  "phoneRequired": "Le numéro de téléphone est requis",
  "phoneInvalid": "Le numéro de téléphone est invalide",
  "licencePlateRequired": "Le numéro de plaque est requis",
  "vehicleRequired": "Le véhicule est requis",
  "acceptTermsOfUseRequired": "Vous devez accepter pour continuer",
  "minimumMustBeLessThanMaximum": "La valeur minimum doit être inférieure à la valeur maximum",
  "promoCodeMinCostMustBeHigherThanPromoCodeValue": "Le coût minimum du code promo doit être supérieur à la valeur du code promo",
  "minNumber": "La valeur doit être supérieure ou égale à {{min}}",
  "maxNumber": "La valeur doit être inférieure ou égale à {{max}}",
  "invalidNumber": "La valeur doit être un nombre"
}
